<template>
  <div class="forgotPassword_box">
    <el-form :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="registerRuleForm" label-width="140px" class="demo-registerRuleForm" label-position="left">
      <el-form-item label="旧密码" prop="password">
        <el-input type="password" v-model="forgotPasswordForm.password" placeholder="密码6-16位，区分大小写" show-password></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="forgotPasswordForm.newPassword" placeholder="密码6-16位，区分大小写" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="renewPassword">
        <el-input type="password" v-model="forgotPasswordForm.renewPassword" placeholder="密码6-16位，区分大小写" show-password></el-input>
      </el-form-item>
      <div class="submit_btn_box m-t-30">
        <el-button type="primary" style="width: 100%;" @click="submitForm('registerRuleForm')">
          提 交
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import smsSend from "@/components/SmsSend";
  import crypto from "@/utils/Crypto";
  import md5 from 'js-md5'
  export default {
    name: "forgotPasswordEdit",
    props: ['address'],
    // import引入的组件需要注入到对象中才能使用
    components: {
      smsSend
    },
    data() {
      // 这里存放数据
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 6 || value.length > 16) {
          callback(new Error('密码必须在6位到16位之间!'));
        } else {
          callback();
        }
      };
      return {
        forgotPasswordForm: {
          password:'',
          newPassword:'',
          renewPassword:'',
        },
        forgotPasswordRules: {
          
          password: [
            { required: true, validator: validatePass, trigger: 'blur' },
          ],
          newPassword: [
            { required: true, validator: validatePass, trigger: 'blur' },
          ],
          renewPassword: [
            { required: true, validator: validatePass, trigger: 'blur' },
          ],
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      // 接口地址
      this.interfaceAddress = this.address;
    },
    // 方法集合
    methods: {
      submitForm(formName) {
        this.forgotPasswordForm.smsType = this.smsType;
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            try {
              this.forgotPasswordForm.password = md5(this.forgotPasswordForm.password);
              this.forgotPasswordForm.newPassword = md5(this.forgotPasswordForm.newPassword);
              this.forgotPasswordForm.renewPassword = md5(this.forgotPasswordForm.renewPassword);
              let res = await this.$http.put(this.interfaceAddress, this.forgotPasswordForm);
              if (res && res.data) {
                await this.$message.success(this.$PubText.successCom);
                await this.$emit('forgotPasswordSuccess')
              }
            } catch (e) {
              console.log(e);
            }
          } else {
            return false;
          }
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .forgotPassword_box {
    width: 100%;

    /deep/ .el-form-item {
      padding-left: 5px;
      padding-right: 0;
      border: 1px solid #409eff;

      .el-input {
        input {
          //background-color: rgba(255, 255, 255, 0.7);
          background-color: transparent;
          border: none;
          padding: 0;
          border-radius: 0;

          &:hover {
            border-color: #409eff;
          }

          &::placeholder {
            color: #5c5c5c;
          }
        }
      }
    }

    .verification_code {
      width: 100%;
      height: 40px;
    }

    .submit_btn_box {
      width: 100%;
      height: 60px;
      text-align: center;
    }
  }
</style>